<cc-top-bar [title]="('PLANS.LABEL' | translate)"></cc-top-bar>

<div class="wrapper" *ngIf="currentSubscription">

  <cc-current-subscription-info [currentSubscription]="currentSubscription"></cc-current-subscription-info>

  <div class="plans-panel-wrapper">
    <cc-plans-panel [currentSubscription]="currentSubscription" [panelForm]="panelForm" [isNotEnoughUsers]="isNotEnoughUsers" [isUserLimitReached]="isUserLimitReached"
    ></cc-plans-panel>
  </div>

  <cc-plans-table [plans$]="plans$"
                  (subscribePlan)="subscribePlan($event)"
                  [subscribeEnabled]="canSubscribePlan.bind(this)"
                  [currentSubscription]="currentSubscription"></cc-plans-table>

</div>
